import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { DisplayListViewModel } from '../DisplayFilters/DisplayListViewModel';
import { IWhereClause } from '../DisplayFilters/WhereFilter';
import {AccountStore} from "../Account/AccountStore";
import {upperFirst} from "lodash";

export interface IDisplayListAggregatesProps {
    readonly vm: DisplayListViewModel;
}

@autoinject
@observer
export class DisplayTopAggregates extends React.Component<IDisplayListAggregatesProps> {
    public render() {
        const { vm } = this.props;
        const { listAggregates } = vm;
        const displayCount = vm.total >= 0 ? vm.total : 0;
        return (
            <Title className="h-100" documentTitle={this.documentTitle}>
                <div className="d-none d-md-block">
                    {displayCount > 0 && listAggregates ? (
                        <div className="px-2">
                            <span className="me-3">{displayCount} Displays</span>
                            <button
                                className="btn btn-link p-3 py-0 aggregate-button"
                                onClick={() => this.onChange(this.options[4])}
                            >
                                <span className={this.aggregateClass(this.options[4])}>
                                    {listAggregates.good} Healthy
                                </span>
                            </button>

                            <button
                                className="btn btn-link p-3 py-0 aggregate-button"
                                onClick={() => this.onChange(this.options[5])}
                            >
                                <span className={this.aggregateClass(this.options[4])}>
                                    {listAggregates.notification} Notification
                                </span>
                            </button>

                            <button
                                className="btn btn-link p-3 py-0 aggregate-button"
                                onClick={() => this.onChange(this.options[2])}
                            >
                                <span className={this.aggregateClass(this.options[2])}>
                                    {listAggregates.warning} Warning
                                </span>
                            </button>

                            <button
                                className="btn btn-link p-3 py-0 aggregate-button"
                                onClick={() => this.onChange(this.options[1])}
                            >
                                <span className={this.aggregateClass(this.options[1])}>
                                    {listAggregates.critical} Critical
                                </span>
                            </button>

                            <button
                                className="btn btn-link p-3 py-0 aggregate-button"
                                onClick={() => this.onChange(this.options[3])}
                            >
                                <span className={this.aggregateClass(this.options[3])}>
                                    {listAggregates.offline} Offline
                                </span>
                            </button>
                        </div>
                    ) : (
                        <div className="px-2">
                            <span>{displayCount} Displays</span>
                        </div>
                    )}
                </div>

                <span className="d-block d-md-none">{displayCount} Displays</span>
            </Title>
        );
    }

    @bind
    @action
    private onChange(option: IWhereClause) {
        if (this.selectedOptions.find(o => o == option)) {
            this.removeWhereFilter(option);
        } else {
            this.setWhereFilter(option);
        }
    }

    @bind
    @action
    private setWhereFilter(option: IWhereClause) {
        this.selectedOptions = [];
        this.selectedOptions.push(option);
        this.props.vm.where = this.selectedOptions;
    }

    @bind
    @action
    private removeWhereFilter(option: IWhereClause) {
        const idx = this.selectedOptions.indexOf(option);
        this.selectedOptions.splice(idx, 1);
        this.props.vm.where = this.selectedOptions;
    }
    
    @computed
    private get documentTitle() {
        if(this.props.vm.isSearching) {
            let accounts = this.props.vm.displayFilter.accounts?.map(a => a.accountName);
            let groups = this.props.vm.displayFilter.displayGroups;
            let cities = this.props.vm.displayFilter.cities;
            let countries = this.props.vm.displayFilter.countries;
            let software = this.props.vm.displayFilter.currentSoftwareVersions;
            let textSearch = this.props.vm.displayFilter.textSearch;
            let titleArray = [accounts, cities, countries, textSearch, groups, software].flat();
            let title = titleArray.filter(e => e !== undefined);
            title = title.filter(e => e);
            let titleString = title.length > 1 ? title.join(', ') : title;
            return upperFirst(this.accountStore.storage.displaysPreference) + ": " + titleString;
        }
    }
    
    @inject
    private accountStore!: AccountStore;
    private aggregateClass(option: IWhereClause) {
        if (this.selectedOptions.find(o => o == option)) {
            return 'aggregate-active';
        }
    }

    private selectedOptions: IWhereClause[] = [];
    private options: IWhereClause[] = [
        {
            option: 'Tour',
            value: 'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Good" && ActiveDisplayStatus?.DisplayStatus=="Online"',
        },
        {
            option: 'Critical',
            value: [
                'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Critical"',
                'ActiveDisplayStatus?.DisplayStatus=="Online"',
            ].join(' && '),
            //    value: 'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Critical"'
        },
        {
            option: 'Warning',
            value: [
                'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Warning"',
                'ActiveDisplayStatus?.DisplayStatus=="Online"',
            ].join(' && '),
        },
        {
            option: 'Offline',
            value: [
                'ActiveDisplayStatus?.DisplayStatus=="TimedOut"',
                'ActiveDisplayStatus?.DisplayStatus=="NeverCommunicated"',
                'ActiveDisplayStatus?.DisplayStatus=="NocCouldNotConnect"',
                'ActiveDisplayStatus?.DisplayStatus=="Communicating"',
                'ActiveDisplayStatus?.DisplayStatus=="NocException"',
            ].join(' || '),
        },
        {
            option: 'Online',
            value: [
                'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Good"',
                'ActiveDisplayStatus?.DisplayStatus=="Online"',
            ].join(' && '),
        },
        {
            option: 'Notification',
            value: 'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Notification"',
        },
    ];
}
